import * as yup from "yup";

export const assessmentSchema = yup.object().shape({
  name: yup
    .string()
    .required("Name is required")
    .matches(/^[a-zA-Z\s]+$/, "Invalid Assessment Name"),
  type: yup.string().required("Type is required"),
});
